<template>
  <section
    ref="section4"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="4"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex max-w-xl flex-col gap-9 lg:w-full">
        <v-error-display :validation-errors="validationErrors"></v-error-display>
        <figure class="flex gap-3">
          <div><v-icon icon="house-dots" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="text-heading-3-desktop">
              Izberite vrsto vaše nepremičnine
            </div>
          </div>
        </figure>
        <form method="POST" :action="routes.submitForm" id="select-estate-type-step">
          <v-csrf-token></v-csrf-token>
          <figure>
            <div
              class="grid grid-cols-2 grid-rows-2 gap-4 lg:flex lg:flex-wrap lg:justify-center items-stretch"
            >
              <div
                name="hisa"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"

              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-1"
                  value="haus"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-1"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/hisa_3.webp'"
                    alt="Hiša"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Hiša</span>
                </label>
              </div>
              <div
                name="novogradnjahisa"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'miete'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-5"
                  value="hausbau"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-5"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/novogradnja_hisa.webp'"
                    alt="Novogradnja hiša"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Novogradnja hiša</span>
                </label>
              </div>
              <div
                name="stanovanje"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-2"
                  value="wohnung"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-2"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/stanovanje_3.webp'"
                    alt="Stanovanje"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Stanovanje</span>
                </label>
              </div>
              <div
                name="stanovanje"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'miete'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-4"
                  value="ind_Schl_3259"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-4"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/novogradnja_stanovanje.webp'"
                    alt="Novogradnja stanovanje"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none text-center">Novogradnja stanovanje</span>
                </label>
              </div>
              <div
                name="parcela"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'miete'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-3"
                  value="grundstueck"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-3"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/parcela.webp'"
                    alt="Parcela"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Parcela</span>
                </label>
              </div>
              <div
                name="soba"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]"
                v-if="stepData.vermarktungsart != 'kauf'"
              >
                <input
                  type="radio"
                  name="objektart"
                  id="real_estate_type-0"
                  value="zimmer"
                  class="hidden"
                  v-model="estateType"
                />

                <label
                  for="real_estate_type-0"
                  class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square"
                >
                  <img
                    :src="$assetsUrl +'/images/soba_3.webp'"
                    alt="Soba"
                    class="pointer-events-none mb-4 w-20 select-none transition-all"
                  />

                  <span class="pointer-events-none select-none">Soba</span>
                </label>
              </div>
            </div>
          </figure>
          <div class="relative py-10" v-if="estateType && estateType != 'zimmer'">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                <div class="w-full border-t border-gray-200"></div>
            </div>
          </div>
          <figure v-if="estateType && estateType != 'zimmer'"
            class="flex flex-col items-start bg-white max-sm:-ml-4 max-sm:-mr-4 max-sm:pl-4 max-sm:pr-4 lg:top-[168px]"
            >
            <div class="flex max-w-lg flex-col gap-8">
                <div class="flex w-full gap-3">
                <div>
                    <v-icon icon="house-work" size="8"></v-icon>
                </div>
                <div class="flex flex-col justify-center">
                    <div class="mb-3 text-heading-3-desktop">
                    <span v-if="estateType !== 'grundstueck'">Izberite tip vaše nepremičnine</span>
                    <span v-else>Kakšni vrsti nepremičnine je namenjena gradnja parcele?</span>
                    </div>
                    <div class="pb-8 text-body-regular text-black-40">
                    Izberete lahko samo eno možnost.
                    </div>
                </div>
                </div>
            </div>
          </figure>
          <figure class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8" v-if="estateType && estateType != 'zimmer'">
            <v-option-dropdown :options="estateTypeOptions" name="objekttyp" label="Tip nepremičnine" :default-value="stepData.objekttyp" ref="estateSubtypeRef" :on-change="onEstateSubypeChange"/>
          </figure>
          <div class="relative py-10" v-if="estateType">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                <div class="w-full border-t border-gray-200"></div>
            </div>
          </div>
          <figure class="flex gap-3" v-if="estateType">
            <div>
                <v-icon icon="home-arrows-circle" size="8"></v-icon>
            </div>
            <div class="flex flex-col justify-center">
                <div class="mb-3 text-heading-3-desktop">
                Nepremičnina se lahko uporabi za
                </div>
                <div class="text-body-regular text-black-40">
                Izberete lahko samo eno možnost.
                </div>
            </div>
          </figure>
          <figure class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8 mt-11 mb-11" v-if="estateType">
            <v-option-dropdown :options="usageTypeOptions" name="nutzungsart" label="Uporaba nepremičnine" :default-value="stepData.nutzungsart" ref="estateUsageRef" :on-change="onUsageChange"/>
            <!--<ul class="flex flex-col gap-8">
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="bivanje"
                    type="radio"
                    value="wohnen"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label for="bivanje" class="w-full text-body-medium-button">
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="bed-single"></v-icon>
                        <div class="text-heading-4-medium">Bivanje</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina se lahko uporablja samo za bivanje za
                        določen ali nedoločen čas. Podrobnosti navedite v opisu
                        nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="poslovniProstor"
                    type="radio"
                    value="gewerbe"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label
                    for="poslovniProstor"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="business"></v-icon>
                        <div class="text-heading-4-medium">Poslovni prostor</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina se lahko uporablja za poslovne namene za
                        določen ali nedoločen čas. Podrobnosti navedite v opisu
                        nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="kratkorocnaOddaja"
                    type="radio"
                    value="waz"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label
                    for="kratkorocnaOddaja"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="timer"></v-icon>
                        <div class="text-heading-4-medium">Krakoročna oddaja</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina je namenjena časovno omejeni oddaji. To so
                        lahko dan, teden ali tedni ali meseci. V tem primeru je
                        večinoma nepremičnin že opremljena. Podrobnosti navedite v
                        opisu nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="nalozba"
                    type="radio"
                    value="anlage"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label for="nalozba" class="w-full text-body-medium-button">
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="chart-data"></v-icon>
                        <div class="text-heading-4-medium">Naložba</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina kot naložba pomeni, da je nepremičnina že
                        oddana ali, da jo vi lahko sami oddate. Podrobnosti
                        navedite v opisu nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
            </ul>-->
          </figure>
        </form>
      </figure>
    </main>
    <v-add-listing-foot>
        <a
            :href="routes.previousStep ? routes.previousStep : '/'"
            class="button button--white button--md h-[48px] w-[240px] px-6 mr-4"
        >
            <v-icon icon="arrow-right" class="rotate-180" size="4"></v-icon>
            <label class="text-small-text-medium">Nazaj</label>
        </a>
      <a
        @click="submitForm('select-estate-type-step')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';
import OptionDropdown from '../OptionDropdown.vue';
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
    "v-option-dropdown": OptionDropdown,
    "v-error-display": ErrorDisplay
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      estateType: null,
      estateSubType: null,
      usageType: null,
    };
  },
  mounted() {
    this.estateType = this.stepData.objektart
    this.estateSubType = this.stepData.objekttyp
    this.usageType = this.stepData.nutzungsart
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
    onEstateSubypeChange(newValue) {
        this.estateSubType = newValue;
    },
    onUsageChange(newValue) {
        this.usageType = newValue;
    }
  },
  watch: {
    estateType: {
        handler (newValue, oldValue) {
            if (oldValue != null) {
                this.estateSubType = null;
                this.usageType = null;
                this.estateSubTypeOption = null;
                this.$refs.estateSubtypeRef.resetValue();
                this.$refs.estateUsageRef.resetValue();
            }
        }
    },
  },
  computed: {
    estateTypeOptions(){
        return this.stepData.objekttyp_options[this.estateType].map((option) => { return {label: option.label, value: option.enum}})
    },
    usageTypeOptions() {
        return [
            {label: 'Bivanje', value: 'wohnen'},
            {label: 'Poslovni prostor', value: 'gewerbe'},
            {label: 'Kratkoročna oddaja', value: 'waz'},
            {label: 'Naložba', value: 'anlage'}
        ];
    },
    validated() {
      if(!this.estateType) {
        return false
      }

      if(this.estateType != 'zimmer' && !this.estateSubType) {
        return false;
      }

      if(!this.usageType) {
        return false;
      }

      return true;
    }
  }
};
</script>
